import { NextSeo, NextSeoProps } from 'next-seo'
import { getFormInitValues, dynamicValidation } from '../src/services/utils'
import { PageContext } from '../src/services/api/types'
import Navigation from '../src/components/navigation/YouFitnessTemplate/Navigation'
import Footer from '../src/components/footer/YouFitnessTemplate/Footer'
import { useFormik } from 'formik'
import { askPasswordFormProps } from '../src/services/api/constants'
import { useRouter } from 'next/router'
import { setCookie } from '../src/services/api/cookies'
import StandardForm from '../src/components/forms/YouFitnessTemplate/StandardForm'
import HeroImage from '../src/components/hero/YouFitnessTemplate/HeroImage'

interface AuthenticatePageProps {
  slug: string
  SEO: NextSeoProps
}

const AuthenticatePage = (props: AuthenticatePageProps) => {
  const { SEO, slug } = props
  const router = useRouter()
  const formik = useFormik({
    initialValues: getFormInitValues(askPasswordFormProps.fields),
    validationSchema: dynamicValidation(askPasswordFormProps.fields),
    onSubmit: (values: any) => {
      setCookie(slug, values.password)
      router.push(`/${slug}`)
    }
  })

  return (
    <>
      <Navigation />
      {SEO && <NextSeo {...SEO} />}
      <HeroImage img='static/imgs/hero.jpeg' />
      <StandardForm
        formik={formik}
        {...askPasswordFormProps}
        style={{ paddingTop: 60 }}
      />
      <Footer />
    </>
  )
}

AuthenticatePage.getInitialProps = async (ctx: PageContext) => {
  const slug = ctx.query && ctx.query.slug ? ctx.query.slug : '/'
  return { slug }
}

export default AuthenticatePage
